<div>
    <h2>Select a Technician</h2>
    <form [formGroup]="form">
        <div>Start typing a first or last name to select an existing technician, or fill out the form to add a new technician.</div>
        <mat-form-field>
            <mat-label>First Name</mat-label>
            <input
                matInput
                formControlName="first_name"
                [matAutocomplete]="techAuto"
                autocomplete="off"
            />
            <mat-autocomplete
                #techAuto="matAutocomplete"
                [displayWith]="displayTechnician"
                (optionSelected)="onTechnicianSelected($event.option.value)"
            >
                <mat-option *ngFor="let r of (results$ | async)" [value]="r">
                {{ r.first_name }} {{ r.last_name }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Last Name</mat-label>
            <input
                matInput
                formControlName="last_name"
                [matAutocomplete]="techLastNameAuto"
                autocomplete="off"
            />
            <mat-autocomplete
                #techLastNameAuto="matAutocomplete"
                [displayWith]="displayTechnician"
                (optionSelected)="onTechnicianSelected($event.option.value)"
            >
                <mat-option *ngFor="let r of (results$ | async)" [value]="r">
                {{ r.first_name }} {{ r.last_name }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Email Address</mat-label>
            <input matInput formControlName="email">
        </mat-form-field>
            <mat-form-field>
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phone">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Home City</mat-label>
            <input matInput formControlName="city">
        </mat-form-field>
            <mat-form-field>
            <mat-label>Home State/Province</mat-label>
            <input matInput formControlName="region">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Country</mat-label>
            <input matInput formControlName="country">
        </mat-form-field>
        <mat-form-field>
            <mat-hint>Please start typing in a technician provider (if relevant) and select an existing provider from the list.</mat-hint>
            <mat-label>Technician Provider</mat-label>
            <input
                matInput
                formControlName="technician_provider"
                [matAutocomplete]="providerAuto"
                autocomplete="off"
            />
            <mat-autocomplete #providerAuto="matAutocomplete" [displayWith]="displayProvider">
                <mat-option *ngFor="let p of providerResults$ | async" [value]="p">
                    {{p.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <!-- <mat-form-field>
            <mat-label>Technician Provider</mat-label>
            <input matInput formControlName="technician_provider_name">
        </mat-form-field> -->
        <div>
            <button mat-raised-button (click)="submit()">Submit</button>
            <button mat-raised-button (click)="closeModal()">Cancel</button>
        </div>
    </form>
</div>